import UbiquaTowerToastAlert from '../alerts/UbiquaTowerToastAlert'
import { dismissDownload, useFileDownloads } from './fileDownloadStore'
import {
  FILE_DOWNLOAD_TOAST_MESSAGES,
  FILE_DOWNLOAD_RETRY_LABEL
} from '../../constants/fileDownloadConstants'

const resolveCopy = (copy, item) => (typeof copy === 'function' ? copy(item) : copy) || {}

/**
 * Avisos globales del estado de las descargas: preparación, éxito, sin datos o error.
 * Se monta una sola vez y observa las tareas iniciadas con runFileDownload.
 * Una descarga puede definir sus propios textos con `toastMessages` en runFileDownload;
 * estos tienen prioridad sobre los textos predeterminados de las constantes.
 *
 * Ejemplo:
 * <FileDownloadToasts />
 */
export default function FileDownloadToasts() {
  const downloads = useFileDownloads()
  return downloads
    .filter((item) => item.visible)
    .slice(-3)
    .map((item, index) => {
      const copy = {
        ...resolveCopy(FILE_DOWNLOAD_TOAST_MESSAGES[item.status], item),
        ...resolveCopy(item.toastMessages?.[item.status], item)
      }
      return (
        <UbiquaTowerToastAlert
          key={item.id}
          id={`${item.id}-${item.status}`}
          severity={
            item.status === 'loading'
              ? 'loading'
              : item.status === 'empty'
                ? 'info'
                : item.status === 'error'
                  ? 'error'
                  : 'success'
          }
          title={copy.title}
          message={copy.message}
          filename={item.filename}
          action={
            item.status === 'error'
              ? {
                  label: FILE_DOWNLOAD_RETRY_LABEL,
                  onClick: () => {
                    dismissDownload(item.id)
                    item.retry()
                  }
                }
              : null
          }
          durationMs={['loading', 'error', 'empty'].includes(item.status) ? null : 6000}
          showCountdown={item.status === 'success'}
          onClose={() => dismissDownload(item.id)}
          snackbarSx={{ top: `${78 + index * 160}px !important` }}
        />
      )
    })
}
